import { h } from "preact";

export const QuantityMinus = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.6665 8L11.3332 8"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const QuantityPlus = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99984 4.66663V11.3333M4.6665 7.99996H11.3332"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const AccordionCaret = ({ className }) => (
  <svg
    className={`icon ${className}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 15L12 7L4 15"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const Info = () => (
  <svg
    className="icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.63031 4.80006H6.88031V8.90006H5.63031V4.80006ZM5.63031 3.09006H6.88031V4.34006H5.63031V3.09006ZM0.570312 6.00006C0.570312 9.14006 3.12031 11.6901 6.26031 11.6901C9.40031 11.6901 11.9503 9.14006 11.9503 6.00006C11.9503 2.86006 9.40031 0.310059 6.26031 0.310059C3.12031 0.310059 0.570312 2.86006 0.570312 6.00006Z"
      fill="currentColor"
    />
  </svg>
);

export const Swatch = () => (
  <svg
    class="icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.2636 4.26625H1.97282C1.7117 4.26625 1.5 4.05887 1.5 3.80304C1.5 3.54721 1.7117 3.3398 1.97282 3.3398H18.2636C18.5247 3.3398 18.7364 3.54721 18.7364 3.80304C18.7364 4.05887 18.5247 4.26625 18.2636 4.26625Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.20914 22.0736H21.5544V6.34171H6.20914V22.0736ZM22.0272 23H5.73636C5.47524 23 5.26354 22.7926 5.26354 22.5368V5.87851C5.26354 5.62268 5.47524 5.41526 5.73636 5.41526H22.0272C22.2883 5.41526 22.5 5.62268 22.5 5.87851V22.5368C22.5 22.7926 22.2883 23 22.0272 23Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.09096 20.4247H19.6726V8.68149H8.09096V20.4247ZM20.1454 21.3512H7.61814C7.35703 21.3512 7.14536 21.1438 7.14536 20.8879V8.21825C7.14536 7.96242 7.35703 7.75504 7.61814 7.75504H20.1454C20.4065 7.75504 20.6182 7.96242 20.6182 8.21825V20.8879C20.6182 21.1438 20.4065 21.3512 20.1454 21.3512Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0272 8.68149H5.73636C5.47524 8.68149 5.26354 8.47411 5.26354 8.21828C5.26354 7.96245 5.47524 7.75504 5.73636 7.75504H22.0272C22.2883 7.75504 22.5 7.96245 22.5 8.21828C22.5 8.47411 22.2883 8.68149 22.0272 8.68149Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.4456 17.6583V1.92645H17.7908V5.73991H18.7364V1.46324C18.7364 1.20741 18.5247 1 18.2636 1H1.97282C1.7117 1 1.5 1.20741 1.5 1.46324V18.1215C1.5 18.3773 1.7117 18.5847 1.97282 18.5847H5.73639V17.6583H2.4456Z"
      fill="currentColor"
    />
  </svg>
);

export const Checkmark = () => (
  <svg
    className="icon"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="22" rx="11" fill="white" />
    <path
      d="M18.3333 6.41666L8.25004 16.5L3.66661 11.9167"
      stroke="black"
      stroke-width="1.14583"
      stroke-linecap="square"
    />
  </svg>
);

// The bare tick, matching the `checkmark` case in snippet.icons.liquid. Unlike
// Checkmark above it brings no disc of its own, so the caller owns the ground.
export const Check = () => (
  <svg
    className="icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0001 9L10 16L7 13"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const Close = () => (
  <svg
    className="icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1L1 11M1.00001 1L11 11"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

// Self-contained dismiss badge: a bordered white disc behind the cross, so it
// stays legible sitting on top of a photo.
export const CloseCircle = () => (
  <svg
    className="icon"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="16"
      height="16"
      rx="8"
      fill="white"
      stroke="#d8d8d8"
    />
    <path
      d="M12.0417 4.95833L4.95833 12.0417M4.95834 4.95833L12.0417 12.0417"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const Tag = () => (
  <svg
    className="icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4052 6.375L6.75 1.71985C6.68061 1.6499 6.59801 1.59444 6.507 1.5567C6.41598 1.51896 6.31838 1.49969 6.21985 1.5H1.875C1.77555 1.5 1.68016 1.53951 1.60984 1.60984C1.53951 1.68016 1.5 1.77555 1.5 1.875V6.21985C1.49969 6.31838 1.51896 6.41598 1.5567 6.507C1.59444 6.59801 1.6499 6.68061 1.71985 6.75L6.375 11.4052C6.44465 11.4748 6.52734 11.5301 6.61834 11.5678C6.70935 11.6055 6.80689 11.6249 6.9054 11.6249C7.0039 11.6249 7.10144 11.6055 7.19245 11.5678C7.28345 11.5301 7.36614 11.4748 7.43579 11.4052L11.4052 7.43579C11.4748 7.36614 11.5301 7.28345 11.5678 7.19245C11.6055 7.10144 11.6249 7.0039 11.6249 6.9054C11.6249 6.80689 11.6055 6.70935 11.5678 6.61834C11.5301 6.52734 11.4748 6.44465 11.4052 6.375ZM6.90516 10.875L2.25 6.21985V2.25H6.21985L10.875 6.90516L6.90516 10.875ZM4.5 3.9375C4.5 4.04876 4.46701 4.15751 4.40521 4.25001C4.3434 4.34251 4.25555 4.41461 4.15276 4.45719C4.04998 4.49976 3.93688 4.5109 3.82777 4.4892C3.71865 4.46749 3.61842 4.41392 3.53976 4.33525C3.46109 4.25658 3.40752 4.15636 3.38581 4.04724C3.36411 3.93813 3.37525 3.82503 3.41782 3.72224C3.4604 3.61946 3.53249 3.53161 3.625 3.4698C3.7175 3.40799 3.82625 3.375 3.9375 3.375C4.08669 3.375 4.22976 3.43427 4.33525 3.53976C4.44074 3.64525 4.5 3.78832 4.5 3.9375Z"
      fill="currentColor"
    />
  </svg>
);

export const Edit = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 6.66667L13.9998 4.66667L11.3332 2L9.33317 4M11.9998 6.66667L5.33317 13.3333H2.6665V10.6667L9.33317 4M11.9998 6.66667L9.33317 4"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DashedSwatchOutline = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="47"
      height="47"
      rx="23.5"
      stroke="currentColor"
      stroke-dasharray="4 4"
    />
  </svg>
);

export const DashedSwatchOutlineSmall = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="23.5"
      height="23.5"
      rx="11.75"
      stroke="white"
      stroke-width="0.5"
    />
    <rect
      x="1.5"
      y="1.5"
      width="21"
      height="21"
      rx="10.5"
      stroke="white"
      stroke-width="2"
    />
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="11"
      stroke="#8E8E8E"
      stroke-width="2"
      stroke-dasharray="2 2"
    />
  </svg>
);
